<template>
  <a-modal
    title="信用证成本"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    :maskClosable="false"
    @ok="() => { $emit('ok', id) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" class="table-page-search-wrapper">
        <a-row>
          <a-col :span="24">
            <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input style="width: 50%" v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入" :disabled="id !== undefined"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开证费" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['issuance_fee', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="开证费"/> RMB
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开证费支出日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['issuance_fee_payment_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="开证费支出日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="承兑费" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['acceptance_fee', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="承兑费"/> RMB
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="承兑费支出日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['acceptance_fee_payment_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="承兑费支出日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金利息" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['margin_interest', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="保证金利息"/> RMB
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="利息收款日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['interest_receipt_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="利息收款日"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="福费廷费用" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['forfaiting_fee', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="福费廷费用"/> RMB
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="福费廷支出日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['forfaiting_fee_payment_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="福费廷支出日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="审单费" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['document_examination_fee', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="审单费"/> RMB
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="审单费支出日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['document_examination_fee_payment_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="审单费支出日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="押汇利息" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['negotiation_interest', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="押汇利息"/> RMB
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="其他费用" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['other_charges', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="其他费用"/> RMB
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import pick from 'lodash.pick'
import { lc_cost_list } from '@/api/trade_credit_letter'

// 表单字段
const fields = ['id', 'business_no', 'issuance_fee', 'issuance_fee_payment_date', 'acceptance_fee', 'acceptance_fee_payment_date', 'margin_interest', 'interest_receipt_date', 'forfaiting_fee',
'forfaiting_fee_payment_date', 'document_examination_fee', 'document_examination_fee_payment_date', 'negotiation_interest', 'other_charges']
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      mdl: undefined,
      loading: false,
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      id: undefined
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  },
  mounted () {
    this.loadLcCostData()
  },
  methods: {
    loadLcCostData () {
      if (this.model['id']) {
        this.loading = true
        lc_cost_list({ lc_issuance_id: this.model['id'] }).then(res => {
          if (res.code === 1000) {
            if (res.data.entries !== undefined && res.data.entries.length > 0) {
              this.loadEditInfo(res.data.entries[0])
            }
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        data['issuance_fee_payment_date'] = this.checkDate(data['issuance_fee_payment_date'])
        data['acceptance_fee_payment_date'] = this.checkDate(data['acceptance_fee_payment_date'])
        data['interest_receipt_date'] = this.checkDate(data['interest_receipt_date'])
        data['forfaiting_fee_payment_date'] = this.checkDate(data['forfaiting_fee_payment_date'])
        data['document_examination_fee_payment_date'] = this.checkDate(data['document_examination_fee_payment_date'])
        const formData = pick(data, fields)
        console.log('formData', formData)
        this.id = formData.id
        formData.type = String(formData.type)
        form.setFieldsValue(formData)
      })
    },
    checkDate (date) {
      if (date === '1970-01-01') {
        return undefined
      } else {
        return date
      }
    }
  }
}
</script>
